'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalServices = void 0;
var transport_1 = require("../../transport");
var ExternalServices = /** @class */ (function () {
    function ExternalServices() {
    }
    ExternalServices.prototype.getChatToken = function (params) {
        return transport_1.transport.request('externalServices/getChatToken', params);
    };
    ExternalServices.prototype.requestToken = function (params) {
        return transport_1.transport.request('externalServices/requestToken', params);
    };
    ExternalServices.prototype.getSessionHash = function () {
        return transport_1.transport.request('externalServices/getSessionHash');
    };
    ExternalServices.prototype.getIntercomToken = function () {
        return transport_1.transport.request('externalServices/intercom-token');
    };
    return ExternalServices;
}());
exports.ExternalServices = ExternalServices;
